// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FZrQ","type":"styles_type__1fsNn","choices":"styles_choices__1a0Gc"};